import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Asset, AssetType } from '@shared/models';

@Component({
  selector: 'interactive-thumbnail',
  templateUrl: './interactive-thumbnail.component.html',
  styleUrls: ['./interactive-thumbnail.component.scss']
})
export class InteractiveThumbnailComponent implements OnInit, OnChanges {
  @Input() asset: Asset | null;
  @Input() height = '94px';
  @Input() width = '168px';
  @Input() isCircular = false;
  @Input() forceContain = false;
  @Input() isNameDisplayed = true;
  @Input() isEditButtonDisplayed = true;
  @Input() displayMode = 'thumbnail';

  @Input() isDeleteButtonDisplayed = false;
  @Input() isDeleteButtonDisabled = false;
  @Input() deleteButtonDisabledTooltips = '';

  @Input() isMediaErrorDisplayed = false;
  @Input() isClickable = true;
  @Input() mediaMissingDisplayedMessage = '';
  @Output() thumbnailClick = new EventEmitter<Asset>();
  @Output() deleteClick = new EventEmitter<Asset>();

  placeholderIcon: string;
  assetSrc: string;

  constructor() {}

  ngOnInit(): void {
    if (!this.asset) {
      return;
    }
    switch (this.asset.type) {
      case AssetType.v2D:
      case AssetType.v360:
      case AssetType.sound: {
        this.placeholderIcon = 'music_video';
        return;
      }
      case AssetType.i2D:
      case AssetType.i360: {
        this.placeholderIcon = 'image';
        return;
      }
      case AssetType.o3D:
      case AssetType.r3D: {
        this.placeholderIcon = '3d_rotation';
        return;
      }
      default: {
        this.placeholderIcon = 'image_not_supported';
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.asset) {
      this.assetSrc = this.displayMode === 'thumbnail' ? this.asset?.thumbnail : this.asset?.path;
    }
  }

  clicked(): void {
    this.thumbnailClick.emit(this.asset);
  }

  deleted($event: any): void {
    $event.stopPropagation();
    this.deleteClick.emit(this.asset);
  }

  getDeleteButtonTooltips(): string {
    if (this.isDeleteButtonDisabled) {
      return this.deleteButtonDisabledTooltips;
    } else {
      return '';
    }
  }
}
